import { memo, useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';

interface IframeViewerProps {
  src: string;
}

const IframeViewer = ({ src }: IframeViewerProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Box
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        background: '#FFFFFF'
      }}>
      <iframe
        src={src}
        title="Quote"
        onLoad={() => setIsLoaded(true)}
        style={{
          border: 0,
          width: '100%',
          height: '100%',
          display: 'block',
          background: '#FFFFFF',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.2s ease'
        }}
      />
      {!isLoaded && (
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#FFFFFF'
          }}>
          <CircularProgress size={64} />
        </Box>
      )}
    </Box>
  );
};

export default memo(IframeViewer);
